import{isObject as e}from"@guildeducationinc/type-guards";import{hasDependencies as n}from"../HasDependencies/HasDependencies.js";var r=function(r){return e(r)&&n(r)};export{r as isFnInput};
//# sourceMappingURL=FnInput.js.map
